<script lang="ts" setup>
import type { DropdownMenuItem } from '@nuxt/ui'

const props = withDefaults(
  defineProps<{
    items?: DropdownMenuItem[]
  }>(),
  {
    items: () => [],
  },
)
</script>

<template>
  <UDropdownMenu
    :items="props.items"
    :content="{ align: 'end' }"
  >
    <UButton
      icon="i-lucide-ellipsis-vertical"
      color="neutral"
      variant="ghost"
      size="md"
    />
  </UDropdownMenu>
</template>
